import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';
import { errore } from './comuni';

// Impostazioni → Comunicazioni (backend/orari_comunicazioni.py): di notte non si disturba il cliente. Fra le ore
// scelte (di base 22–09, ora di Roma) le azioni dello staff non arrivano al cliente sul momento: email, push e
// campanella si accumulano e partono la mattina in un solo avviso per cliente, con i link alle cose. Sette giorni
// su sette. Restano immediati i messaggi che non possono aspettare (elenco "sempre_subito", dal catalogo).
const ORE = Array.from({ length: 24 }, (_, i) => i);
const ora = (h) => `${String(h).padStart(2, '0')}:00`;

const Comunicazioni = () => {
  const [dati, setDati] = useState(null);
  const [form, setForm] = useState(null);
  const [salvo, setSalvo] = useState(false);
  useEffect(() => {
    axios.get(`${API}/impostazioni/comunicazioni`)
      .then((r) => { setDati(r.data); setForm({ attivo: r.data.attivo, inizio: r.data.inizio, fine: r.data.fine }); })
      .catch(() => setDati({ errore: true }));
  }, []);
  const salva = async () => {
    setSalvo(true);
    try {
      const r = await axios.put(`${API}/impostazioni/comunicazioni`, form);
      setDati({ ...dati, ...r.data });
      setForm({ attivo: r.data.attivo, inizio: r.data.inizio, fine: r.data.fine });
      toast.success(r.data.attivo ? `Di notte niente messaggi: dalle ${ora(r.data.inizio)} alle ${ora(r.data.fine)}` : 'I messaggi partono sempre subito');
    } catch (e) { toast.error(errore(e, 'Non salvato')); } finally { setSalvo(false); }
  };
  if (!dati || !form) return <p className="vuoto">Carico le comunicazioni…</p>;
  if (dati.errore) return <p className="vuoto">Non riesco a leggere gli orari.</p>;
  const cambiato = form.attivo !== dati.attivo || form.inizio !== dati.inizio || form.fine !== dati.fine;
  const scelta = (chiave, testo) => (
    <label>
      {testo}
      <select value={form[chiave]} disabled={!form.attivo} onChange={(e) => setForm({ ...form, [chiave]: Number(e.target.value) })}>
        {ORE.map((h) => <option key={h} value={h}>{ora(h)}</option>)}
      </select>
    </label>
  );
  return (
    <div className="imp-griglia" data-testid="comunicazioni">
      <section className="card">
        <div className="ttl"><div className="i"><Icona nome="orologio" /></div><h2>Di notte non si disturba il cliente</h2>
          {dati.silenzio && <span className="tag t-b">adesso è l&apos;ora del silenzio</span>}
        </div>
        <p className="imp-nota">
          Quello che fate fra le {ora(form.inizio)} e le {ora(form.fine)} non arriva al cliente sul momento: email, push e campanella si
          accumulano e partono alle {ora(form.fine)}, in un solo avviso per cliente («Ieri sera abbiamo: …») con i link alle cose. Sette
          giorni su sette, sempre con l&apos;ora di Roma (adesso sono le {dati.adesso}).
        </p>
        <div className="imp-azioni">
          <label className="spunta">
            <input type="checkbox" checked={form.attivo} onChange={(e) => setForm({ ...form, attivo: e.target.checked })} />
            Di notte i messaggi aspettano
          </label>
        </div>
        <div className="imp-campi">{scelta('inizio', 'Dalle')}{scelta('fine', 'Alle')}</div>
        <div className="imp-azioni">
          <button type="button" className="btn sm p" disabled={!cambiato || salvo} onClick={salva}>{salvo ? 'Salvo…' : 'Salva'}</button>
          <span className="imp-nota" data-testid="comunicazioni-coda">
            {dati.in_coda ? `${dati.in_coda === 1 ? '1 messaggio aspetta' : `${dati.in_coda} messaggi aspettano`} le ${dati.prossima_uscita}.` : 'Niente in attesa.'}
          </span>
        </div>
      </section>
      <section className="card">
        <div className="ttl"><div className="i b"><Icona nome="campanella" /></div><h2>Partono sempre subito</h2></div>
        <p className="imp-nota">
          Anche di notte: quello che serve per entrare, per firmare o per non perdere una visita. Le comunicazioni fra noi, e quelle ad
          agenzie, banche e notai, non aspettano mai.
        </p>
        <div className="imp-azioni">
          {(dati.sempre_subito || []).map((e) => <span key={e.id} className="chip" style={{ cursor: 'default' }}>{e.nome}</span>)}
        </div>
      </section>
    </div>
  );
};

export default Comunicazioni;
